// Each reward machine's own words (B16). Child-facing strings take these instead of saying
// "capsule"; the server's push notifications use them too ("Your free capsule is ready").
import type { RewardMachineId } from './rewards'

export interface MachineWords {
  /** The thing a play opens: "capsule", "chest". */
  one: string
  /** Its plural: "capsules", "chests". */
  many: string
  /** The cabinet: "capsule machine", "treasure chest". */
  cabinet: string
  /** The main button: "Twist for a capsule", "Open the chest". */
  action: string
  /** The verb on its own, for hints: "twist", "open". */
  verb: string
  /** After a round: "Capsule cleared!", "Chest opened!". */
  cleared: string
}

export const MACHINE_WORDS: Record<RewardMachineId, MachineWords> = {
  gashapon: { one: 'capsule', many: 'capsules', cabinet: 'capsule machine', action: 'Twist for a capsule', verb: 'twist', cleared: 'Capsule cleared!' },
  chest: { one: 'chest', many: 'chests', cabinet: 'treasure chest', action: 'Open the chest', verb: 'open', cleared: 'Chest opened!' },
  // Korea's claw machine (B16, still K8-MJ78-11): the claw never misses, the draw is decided first.
  claw: { one: 'ball', many: 'balls', cabinet: 'claw machine', action: 'Drop the claw', verb: 'drop', cleared: 'Got one!' },
}
